import type React from 'react';

import { OrdReferenceManyInput } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { SipIdentityExtensionUpdateFields } from '@ragu-components/ord-types';
import { TextInput } from 'react-admin';

import { SipIdentityInputs } from '../sipIdentities/SipIdentityInputs';

import type { FormType } from '@ragu-components/ord-components';
import type { RaRecord } from 'react-admin';

export interface EmbeddedSipIdentityProps {
  record?: RaRecord;
  type: FormType;
}

export const EmbeddedSipIdentity = ({ record = undefined, type }: EmbeddedSipIdentityProps): React.ReactElement => {
  return (
    <OrdReferenceManyInput
      reference={Resources.sip_identities}
      target={
        type === 'create'
          ? SipIdentityExtensionUpdateFields.extension
          : `${SipIdentityExtensionUpdateFields.extension}.id`
      }
      replaceRelationships={['labels', 'assigned_sip_profile', 'extension']}
      record={record}
    >
      <SipIdentityInputs type={type} />
      {type !== 'create' && (
        <TextInput
          source={SipIdentityExtensionUpdateFields.extension}
          readOnly
          defaultValue={record?.id}
          sx={{ display: 'none' }}
        />
      )}
    </OrdReferenceManyInput>
  );
};
